<template>
<w-sliding-popup type="setting" ref="slidingPopup" title="모델 변경" @close="close" width="500px" >
  <el-form slot="content" :model="modelInfo" label-position="top" ref="modelInfoForm">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="모델 OID" prop="objOid">
          <el-input v-model="modelInfo.objOid" disabled />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="벤더사 명" prop="objCompanyName">
          <el-input v-model="modelInfo.objCompanyName" disabled />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="장비 종류" prop="objtypeId" :rules="{ trigger: 'change', required: true, message: '필수 정보입니다.' }">
          <el-select v-model="modelInfo.objtypeId" filterable style="width:100%" :allow-create="false" default-first-option>
            <el-option v-for="item in objtypeList" :key="item.objtypeId" :label="item.objtypeName" :value="item.objtypeId"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item v-if="!isCustomProductId" label="모델 명" prop="objProductId" :rules="{ trigger: 'change', required: true, message: '필수 정보입니다.' }">
          <div style="display:flex">
            <div class="mr-r4" style="width:calc(100% - 34px);">
              <el-select v-model="modelInfo.objProductId" filterable style="width:100%" :allow-create="false" default-first-option>
                <el-option v-for="item in productInfoList" :key="`${item.objCompanyId}${item.objProductId}`" :label="item.objProductId" :value="item.objProductId"></el-option>
              </el-select>
            </div>
            <el-button size="mini" type="content" icon="fas fa-pen" @click="isCustomProductId = !isCustomProductId" />
          </div>
        </el-form-item>
        <el-form-item v-else label="모델 명" prop="customProductId" :rules="{ trigger: 'blur', required: true, message: '필수 정보입니다.' }">
          <div style="display:flex">
            <div class="mr-r4" style="width:calc(100% - 34px);">
              <el-input v-model="modelInfo.customProductId" style="width:100%" />
            </div>
            <el-button size="mini" type="content" icon="fas fa-pen" @click="isCustomProductId = !isCustomProductId" />
          </div>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
  <el-row slot="footer" type="flex" justify="center">
    <el-button size="large" class="mr-r4" type="solid" @click="saveModelOid">저장</el-button>
    <el-button size="large" @click="closePopup">취소</el-button>
  </el-row>
</w-sliding-popup>
</template>

<script>
import { isNil } from 'lodash';
import msgUtil from '@/utils/message';
import ProductAPI from '@/api/model/obj-product';
import NetdeviceSettingAPI from '@/api/settings/netdevice/netdevice-settings';
import ObjtypeAPI from '@/api/model/objtype';

export default {
  name: 'WSetModelOidPopup',
  data() {
    return {
      objtypeList: [],
      productInfoList: [],
      isCustomProductId: false,
      modelInfo: {
        objCompanyId: null,
        objCompanyName: null,
        objProductId: null,
        customProductId: null,
        objOid: null,
        objtypeId: null,
      },
    };
  },
  watch: {
    isCustomProductId() {
      this.$refs.modelInfoForm.clearValidate('objProductId');
      this.$refs.modelInfoForm.clearValidate('customProductId');
    },
    'modelInfo.customProductId': {
      handler(value) {
        if (!isNil(value)) {
          if (!isNil(this.$refs.modelInfoForm)) {
            this.$refs.modelInfoForm.validateField('customProductId');
          }
        }
      },
    },
  },
  created() {
    ObjtypeAPI.getObjtypeList('NMS').then((response) => {
      const result = response.data;
      if (result.success) {
        this.objtypeList = result.data;
      } else {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '장비 종류 목록', result.success));
      }
    }).catch(() => {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '장비 종류 목록', false));
    });
  },
  methods: {
    close() {
      this.isCustomProductId = false;
      this.$refs.modelInfoForm.resetFields();
    },
    closePopup() {
      this.$refs.slidingPopup.visible = false;
    },
    open(row) {
      this.$refs.slidingPopup.open();
      this.modelInfo = row;
      this.loadProductList();
    },
    loadProductList() {
      if (!isNil(this.modelInfo.objCompanyId)) {
        ProductAPI.getObjProductListByCompany({ objCompanyId: this.modelInfo.objCompanyId }).then((result) => {
          if (result.data.success) {
            this.productInfoList = result.data.data;
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '모델 목록', result.data.success));
          }
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '모델 목록', false));
        });
      }
    },
    saveModelOid() {
      this.$refs.modelInfoForm.validate((valid) => {
        if (valid) {
          const saveParmas = {
            objCompanyId: this.modelInfo.objCompanyId,
            objProductId: this.isCustomProductId ? this.modelInfo.customProductId : this.modelInfo.objProductId,
            objtypeId: this.modelInfo.objtypeId,
            objOid: this.modelInfo.objOid,
          };
          NetdeviceSettingAPI.updateNetdeviceModelInfo(saveParmas).then((response) => {
            if (response.data.success) {
              this.closePopup();
              this.$emit('reload-data');
            }
            this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, '모델 OID', response.data.success));
          }).catch(() => {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, '모델 OID', false));
          });
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/netdevice/OidSettings/VendorModelOidSettings/component/ModelOidSettingView/popup/SetModelOidPopup.vue